// extracted by mini-css-extract-plugin
export default {"footer":"Bundles_footer__f5rhg","change-default-price-link":"Bundles_change-default-price-link__V7PnB"};